// extracted by mini-css-extract-plugin
module.exports = {"container":"FailedTransaction_container__3-z9P"};